import { useEffect, useState, useCallback } from "react";
import { getUser } from "../../../shared/services/services";
import { IUser } from "../../../shared/services/interface";
import { useUser } from "../components/UserContext";

const useUsers = () => {
  const { setUser } = useUser();
  const [users, setUsers] = useState<IUser>();
  const [loading, setLoading] = useState<boolean>(true);

  const loadUsers = useCallback(() => {
    setLoading(true);

    getUser()
      .then((res) => {
        const filtered = res.data.user_details;
        setUsers(filtered);
        setUser(filtered);
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [setUser]);

  // Load users on mount
  useEffect(() => {
    loadUsers();
  }, [loadUsers]);

  return { users, loading, reload: loadUsers };
};

export default useUsers;
